import { VF_DROPDOWN } from 'AppSrc/core/components/forms/form-base-components/v-f-dropdown';
import { CATEGORISED_TYPEAHEAD } from 'AppSrc/core/components/forms/form-base-components/sub-components/drop-down-components/templates/dropdown-templates';
import {
  INLINE_ERRORS,
  commonValidation,
  cleanUpFieldErrors,
  getDefaultFieldErrors,
} from 'AppSrc/core/components/forms/form-base-components/utility/common-validation';
import { getDisplayOptions } from 'AppSrc/core/components/forms/form-base-components/redux/display-options/actions-display-options';
import {
  VODAFONE_UK,
} from 'AppSrc/core/components/forms/value-dependency-constants';

const fieldId = 'company';

const validator = (params) => {
  const {
    values,
    field,
  } = params;
  const {
    optional,
  } = field;

  /* MAKE A DEFAULT ERRORS OBJECT */
  const errors = getDefaultFieldErrors();

  /* ERROR CHECKERS */
  const noValue = commonValidation.noValue(values[fieldId], VF_DROPDOWN);

  /* ADD ERRORS TO ERROR OBJECT */
  errors[INLINE_ERRORS].push((noValue && !optional) ? 'Please select an option' : null);

  /* REMOVE BLANK ERRORS (because Formik gets confused) */
  return cleanUpFieldErrors(errors);
};


const initialValues = VODAFONE_UK;

const vFParams = {
  fieldTitle: 'Search Company',
  placeholder: 'Enter Company',
  optionTemplate: CATEGORISED_TYPEAHEAD,
  withRedux: true,
  getDisplayOptionsOnMount: () => getDisplayOptions({
    fieldId,
    endpointKey: 'change_location',
    preventRefresh: true, // the list is static so we only want to get it once, not every time the component mounts.
  }),
};

const company = {
  id: fieldId,
  validator,
  initialValues,
  vFParams,
  fieldType: VF_DROPDOWN,
};

export { company };
